<template>
  <v-container fluid>
    <toolbar mode="application" :item="application">
      <v-spacer/>
      <template v-if="item">
        {{ item.name }}
        <ax-button @clicked="uuid = null" icon="mdi-close" tooltip="Close file" />
      </template>
    </toolbar>
    <v-card v-if="item">
      <v-card-text>
        <v-row>
          <v-col cols="2">
            <v-autocomplete
              v-model="models.selected"
              :items="models.list"
              label="Prediction Model"
            />
            <v-autocomplete
              v-model="formation.selected"
              :items="formation.list"
              label="Formations"
            />
            <v-text-field
              :value="getLatitude"
              :label="`${filters.LatWGS84.label} (${filters.LatWGS84.value})`"
            />
            <v-text-field 
              :value="getLongitude" 
              :label="`${filters.LonWGS84.label} (${filters.LonWGS84.value})`"
            />
            <template v-for="slider in Object.keys(filters)">
              <template v-if="slider == 'LatWGS84' || slider == 'LonWGS84'"></template>
              <div v-else :key="filters[slider].id">
                <span>{{ filters[slider].label }}</span>
                <!-- <v-chip v-if="slider=='LatWGS84'" x-small class="ml-1">{{ getLatitude() }}</v-chip>
                      <v-chip v-else-if="slider=='LonWGS84'" x-small class="ml-1">{{ getLongitude() }}</v-chip> -->
                <v-chip x-small class="ml-1">{{ filters[slider].value }}</v-chip>
                <v-slider
                  v-model="filters[slider].value"
                  :min="filters[slider].min"
                  :max="filters[slider].max"
                  :step="(filters[slider].max - filters[slider].min) / split"
                  @change="onSlide"
                ></v-slider>
              </div>
            </template>
            <span class="">End of Life (months)</span>
            <v-chip x-small class="ml-1">{{ life.value | numberFormat }}</v-chip>
            <v-slider v-model="life.value" :max="life.max" :min="life.min" :step="life.step"></v-slider>
          </v-col>
          <v-col cols="5">
            <template v-if="plot.data.length">
              <vue-plotly
                class="full mb-3"
                :data="plot.data"
                :layout="plot.layout"
                :options="plot.options"
                @selected="onMapSelect"
              />
              <v-chip-group v-model="selectedWell" active-class="primary--text">
                <v-chip
                  v-for="well in wells"
                  :key="well.id"
                  close
                  :value="well"
                  @click:close="onRemoveWell(well)"
                >
                  Virtual Well #{{ well.id }}
                </v-chip>
              </v-chip-group>
            </template>
          </v-col>
          <v-col cols="5">
            <template v-if="selectedWell">
              <div class="d-flex mb-3">
                <div class="d-flex flex-column flex-grow-1">
                  <h4 class="mb-0 primary--text">Cumulative Production</h4>
                  <p class="mb-0">From first {{ this.chart.data[0].y.length }} months of predicted production</p>
                </div>
                <div class="d-flex align-center">
                  <span class="font-weight-medium display-1 mr-1">{{ production | numberFormat }}</span>
                  <small class="text-muted">bbl</small>
                </div>
              </div>
              <div class="d-flex">
                <div class="d-flex flex-column flex-grow-1">
                  <h4 class="mb-0 success--text">Estimated Ultimate Recovery</h4>
                  <p class="mb-0">Declined forecast for upto {{ life.value }} months</p>
                </div>
                <div class="d-flex align-center">
                  <span class="font-weight-medium display-1 mr-1">{{ curved_eur | numberFormat }}</span>
                  <small class="text-muted">bbl</small>
                </div>
              </div>
              <vue-plotly :data="chart.data" :layout="chart.layout" :options="chart.options" />
            </template>
            <template v-else>
              <v-card-text class="pa-16 grey--text" :class="[ isDark ? 'text--lighten': 'text--darken' ]">
                <p class="mx-16 mt-16 text-h4">Create and select a well</p>
                <p class="mx-16">To create a new well&hellip;</p>
                 <ul class="mx-16 mb-4">
                  <li><v-icon>mdi-lasso</v-icon> Drag a shape on the map where you want to place the well</li>
                  <li><v-icon>mdi-checkbox-marked</v-icon> Select the newly created well in the list below the map</li>
                </ul>
                <p class="mx-16">To select a single well&hellip;</p>
                <ul class="mx-16 mb-4">
                  <li><v-icon>mdi-bullseye</v-icon> Select a well in the list below the map</li>
                  <li><v-icon>mdi-cursor-pointer</v-icon> Adjust the parameters on the left, and review changes</li>
                </ul>
              </v-card-text>
            </template>
          </v-col>
        </v-row>

        <!-- <v-data-table
            :headers="headers"
            :items="wells"
            :items-per-page="100"
            class="text-truncate"
            disable-filtering
            disable-sort
            hide-default-footer
          /> -->
      </v-card-text>
    </v-card>
    <dlg-open-file v-else mode="file" :name="application.name" @submitted="uuid=$event" />
  </v-container>
</template>
<script>
import Files from '@/api/files'
import VirtualWell from '@/api/virtualwell'
import AxButton from '@/components/button'
import toolbar from '@/components/toolbar'
import dlgOpenFile from '@/components/open'
import VuePlotly from '@statnett/vue-plotly'
export default {
  name: "VirtualWell",
  props: ["application"],
  components: {
    AxButton,
    toolbar,
    dlgOpenFile,
    VuePlotly
  },
  data() {
    return {
      uuid: null,
      item: null,
      filters: {
        LatWGS84: { label: "Latitude", min: -90, max: 90, value: "" },
        LonWGS84: { label: "Longitude", min: -180, max: 80, value: "" },
        LATERAL_LENGTH_BLEND: { label: "Lateral Length", min: 4000, max: 10000, value: 0 },
        PROP_PER_FOOT: { label: "Proppant / Foot", min: 500, max: 4000, value: 0 },
        WATER_PER_FOOT: { label: "Water / Foot", min: 200, max: 3000, value: 0 }
      },
      models: {
        selected: "EAGLE",
        list: [
          { text: 'Anadarko', value: 'ANADARKO' },
          { text: 'Denver', value: 'DENVER' },
          { text: "Eagleford", value: "EAGLE" },
          { text: 'Permian', value: 'PERMIAN' },
          { text: 'Williston', value: 'WILLISTON' },
        ]
      },
      formation: {
        selected: "OTHER",
        list: [
          { text: "Bakken", value: "BAKKEN" },
          { text: "Canyon", value: "CANYON" },
          { text: "Niobrara", value: "NIOBRARA" },
          { text: "Spraberry", value: "SPRABERRY" },
          { text: "Wolfcamp", value: "WOLFCAMP" },
          { text: "Other", value: "OTHER" }
        ]
      },
      fields: null,
      frame: null,
      values: {},
      split: 1000,
      predictions: null,
      life: {
        min: 0,
        max: 600,
        value: 600,
        step: 12,
        units: "months"
      },
      wells: [],
      selectedWell: undefined, 
      counter: 0,
      headers: [
        { text: "ID", value: "id" },
        { text: "Latitude", value: "latitude" },
        { text: "Longitude", value: "longitude" }
      ],
      remove: false,
      plot: {
        data: [],
        layout: {
          autosize: true,
          hovermode: "closest",
          showlegend: false,
          height: 650,
          mapbox: { style: "mapbox://styles/schajee/cl1kethtn00sc14qo74wioif5", bearing: 0, center: { lat: 0, lon: 0 }, pitch: 0, zoom: 8 },
          font: { family: "Roboto, sans-serif", color: '#808080' },
          margin: { l: 0, r: 0, b: 0, t: 0, pad: 0 },
          paper_bgcolor: "rgba(0,0,0,0)",
          plot_bgcolor: "rgba(0,0,0,0)",
        },
        options: {
          mapboxAccessToken: process.env.VUE_APP_MAPBOX_TOKEN,
          displayModeBar: true,
          responsive: true,
          displaylogo: false,
          modeBarButtonsToRemove: ["toImage", "toggleHover"]
        }
      },
      chart: {
        data: [
          {
            name: "Prediction",
            type: "bar",
            x: this.create_array(),
            y: [],
            marker: { color: "#BDBDBD" }
          },
          {
            name: "Arps",
            mode: "lines",
            x: this.create_array(),
            y: [],
            line: { color: "#F44336" }
          }
        ],
        layout: {
          autosize: true,
          showlegend: true,
          legend: { x: 0.75, y: 1 },
          font: { family: "Roboto, sans-serif", color: '#808080' },
          xaxis: { title: { text: "Relative Time (months)" }, dtick: 12 },
          yaxis: { title: { text: "Prediction Forecast (bbl)" } },
          hovermode: "closest",
          height: 320,
          margin: { r: 15, b: 40, t: 15 },
          paper_bgcolor: "rgba(0,0,0,0)",
          plot_bgcolor: "rgba(0,0,0,0)"
        },
        options: {
          displayModeBar: false,
          responsive: true
        }
      }
    }
  },
  watch: {
    "uuid": function(val, old) {
      if (val) {
        Files.retrieve(this.uuid).then(response => {
          this.item = response.data
          this.loadData()
        })
      } else {
        this.item = null
      }
    },
    wells() {
      this.plotWells()
    },
    selectedWell(val) {
      this.setFilters()
      if (val) {
        this.plotSelectedWell()
        this.fetchPredictions()
      } else {
        this.plot.data = this.plot.data.filter(t => t.name !== 'selected')
      }
    },
    'models.selected'(val) {
      if (val) {
        if (this.selectedWell !== undefined) {
          this.selectedWell.model = val
          this.fetchPredictions()
        }
      }
    },
    'formation.selected'(val) {
      if (val) {
        if (this.selectedWell !== undefined) {
          this.selectedWell.formation = val
          this.fetchPredictions()
        }
      }
    }
  },
  computed: {
    /**
     * Computes total production
     */
    production() {
      return this.chart.data[0].y.reduce((a, b) => a + b, 0)
    },
    /**
     * Calculate EUR
     */
    curved_eur() {
      if (this.life.value <= this.chart.data[0].y.length) {
        return this.chart.data[0].y.slice(0, this.life.value).reduce((a, b) => a + b, 0)
      } else {
        return (
          this.chart.data[0].y.slice(0, this.life.value).reduce((a, b) => a + b, 0) +
          this.chart.data[1].y.slice(0, this.life.value).reduce((a, b) => a + b, 0)
        )
      }
    },
    getLatitude() {
      const lat = this.filters.LatWGS84.value
      var latitude = this.toDegreesMinutesAndSeconds(lat)
      var latitudeCardinal = lat >= 0 ? "N" : "S"

      return latitude + " " + latitudeCardinal
    },
    getLongitude() {
      const lon = this.filters.LonWGS84.value
      var longitude = this.toDegreesMinutesAndSeconds(lon)
      var longitudeCardinal = lon >= 0 ? "E" : "W"
      return longitude + " " + longitudeCardinal
    },
    latMask() {
      return this.filters.LatWGS84.value >= 0 ? "## ## ## N" : "## ## ## S"
    },
    lonMask() {
      return this.filters.LonWGS84.value >= 0 ? "## ## ## E" : "## ## ## W"
    }
  },
  methods: {
    loadData() {
      Files.frame(this.item.uuid).then(response => {
        this.frame = response.data
        // this.setFilters()
        this.plotMap()
        // this.fetchPredictions()
      })
    },
    setFilters() {
      const LAT = "LatWGS84" in this.frame ? "LatWGS84" : "Latitude" in this.frame ? "Latitude" : "Surface Latitude"
      const LON = "LonWGS84" in this.frame ? "LonWGS84" : "Longitude" in this.frame ? "Longitude" : "Surface Longitude"
      this.filters.LatWGS84.min = Math.min(...Object.values(this.frame[LAT]))
      this.filters.LatWGS84.max = Math.max(...Object.values(this.frame[LAT]))
      this.filters.LonWGS84.min = Math.min(...Object.values(this.frame[LON]))
      this.filters.LonWGS84.max = Math.max(...Object.values(this.frame[LON]))
    },
    /**
     * Populate plot data; calculate map center
     */
    plotMap() {
      const LAT =
        "LatWGS84" in this.frame
          ? "LatWGS84"
          : "Latitude" in this.frame
          ? "Latitude"
          : "Surface Latitude" in this.frame
          ? "Surface Latitude"
          : null
      const LON =
        "LonWGS84" in this.frame
          ? "LonWGS84"
          : "Longitude" in this.frame
          ? "Longitude"
          : "Surface Longitude" in this.frame
          ? "Surface Longitude"
          : null
      if (LAT && LON) {
        let mapObject = {
          name: 'all',
          type: "scattermapbox",
          lat: Object.values(this.frame[LAT]),
          lon: Object.values(this.frame[LON]),
          mode: "markers",
          hoverinfo: "none",
          marker: {
            size: 3,
            color: "rgba(0,0,0,0.5)"
          }
        }
        // Find center latitude
        this.plot.layout.mapbox.center.lat = mapObject.lat.reduce(function(p, c, i, a) {
          return p + c / a.length
        }, 0)
        // Find center longitude
        this.plot.layout.mapbox.center.lon = mapObject.lon.reduce(function(p, c, i, a) {
          return p + c / a.length
        }, 0)

        this.plot.data = [mapObject]
        this.filters.LatWGS84.value = this.plot.layout.mapbox.center.lat
        this.filters.LonWGS84.value = this.plot.layout.mapbox.center.lon

        this.filters.LatWGS84.label = LAT
        this.filters.LonWGS84.label = LON
      }
    },
    plotWells() {
      this.plot.data = this.plot.data.filter(t => t.name == 'all')
      // Populate wells in new layer
      let mapObject = {
        name: 'wells',
        type: "scattermapbox",
        text: this.wells.map(w => w.id),
        lat: this.wells.map(w => w.latitude),
        lon: this.wells.map(w => w.longitude),
        mode: "markers",
        hoverinfo: "none",
        marker: {
          size: 8,
          color: '#2196F3',
        }
      }
      this.plot.data.push(mapObject)
    },
    plotSelectedWell() {
      this.plot.data = this.plot.data.filter(t => t.name !== 'selected')
      this.plot.data.push({
        name: 'selected',
        type: "scattermapbox",
        text: [this.selectedWell.id],
        lat: [this.selectedWell.latitude],
        lon: [this.selectedWell.longitude],
        mode: "markers",
        hoverinfo: "none",
        marker: {
          size: 12,
          color: '#F44336',
        }
      })
    },
    setFilters() {
      if (this.selectedWell !== undefined) {
        this.filters.LatWGS84.value = this.selectedWell.latitude
        this.filters.LatWGS84.value = this.selectedWell.latitude
        this.filters.LonWGS84.value = this.selectedWell.longitude
        this.filters.LATERAL_LENGTH_BLEND.value = this.selectedWell.lateral
        this.filters.PROP_PER_FOOT.value = this.selectedWell.proppant
        this.filters.WATER_PER_FOOT.value = this.selectedWell.water
      } else {
        Object.entries(this.filters).forEach(f => {
          f['value'] = f['min']
        })
      }
    },
    onSlide(event) {
      if (this.selectedWell !== undefined) {
        // well.latitude = this.filters.LatWGS84.value
        // well.longitude = this.filters.LonWGS84.value
        this.selectedWell.lateral = this.filters.LATERAL_LENGTH_BLEND.value
        this.selectedWell.proppant = this.filters.PROP_PER_FOOT.value
        this.selectedWell.water = this.filters.WATER_PER_FOOT.value
        this.fetchPredictions()
      } else {
        this.notify("Please create a virtual well", "error")
      }
    },
    fetchPredictions() {
      VirtualWell.predict(this.uuid, this.filtered()).then(response => {
        this.chart.data[0].y = response.data["predicted"]
        this.chart.data[0].x = this.create_array(1, this.chart.data[0].y.len)
        this.chart.data[0].marker.color = this.create_array(1, this.chart.data[0].y.len, "#BDBDBD")
        this.chart.data[1].y = response.data["extended"]
        this.chart.data[1].x = this.create_array(25, this.chart.data[1].y.len)
        this.chart.data[1].line.color = "#F00"
      })
    },
    /**
     * Handle the select event on map;
     * Creates a point in the center of the selection
     * Sends request for updated predictions on current well
     */
    onMapSelect(event) {
      if (event && "range" in event) {
        const a = event.range.mapbox[0]
        const b = event.range.mapbox[1]
        const x = (a[0] + b[0]) / 2
        const y = (a[1] + b[1]) / 2

        const well = {
          id: this.counter + 1,
          latitude: y,
          longitude: x,
          model: this.models.selected,
          formation: this.formation.selected,
          lateral: this.filters.LATERAL_LENGTH_BLEND.value,
          proppant: this.filters.PROP_PER_FOOT.value,
          water: this.filters.WATER_PER_FOOT.value
        }
        this.counter++
        this.wells.push(well)
      }
    },
    /**
     * Remove virtual well
     */
    onRemoveWell(well) {
      this.wells = this.wells.filter(w => w.id !== well.id)
      this.plotWells()
    },
    onReset() {
      this.well = null
      this.wells = []
      this.loadData()
      this.plot.data[1].lat = []
      this.plot.data[1].lon = []

    },
    /**
     * Return a list of non-null filters for list params
     */
    filtered() {
      return {
        model: this.selectedWell.model,
        formation: this.selectedWell.formation,
        Latitude: 'LatWGS84',
        Longitude: 'LonWGS84',
        LatWGS84: this.selectedWell.latitude,
        LonWGS84: this.selectedWell.longitude,
        LATERAL_LENGTH_BLEND: this.selectedWell.lateral,
        PROP_PER_FOOT: this.selectedWell.proppant,
        WATER_PER_FOOT: this.selectedWell.water
      }
    },
    /**
     * Determine if input arrays are equal or not
     */
    equals(a, b) {
      if (!a || !b) return false
      if (a.length != b.length) return false
      for (var i = 0, l = a.length; i < l; i++) if (a[i] != b[i]) return false
      return true
    },
    toDegreesMinutesAndSeconds(coordinate) {
      var absolute = Math.abs(coordinate)
      var degrees = Math.floor(absolute)
      var minutesNotTruncated = (absolute - degrees) * 60
      var minutes = Math.floor(minutesNotTruncated)
      var seconds = Math.floor((minutesNotTruncated - minutes) * 60)
      return (
        degrees.toString().padStart(2, "0") +
        " " +
        minutes.toString().padStart(2, "0") +
        " " +
        seconds.toString().padStart(2, "0")
      )
    }
  }
}
</script>